@if (hasTitlebar) {
    <div class="titlebar">
        <div class="title-con">
            <div class="title" helpTooltip [helpContentId]="helpContentId" [helpDisabled]="!helpContentId">
                <h3>{{ header }}</h3>
            </div>
        </div>
        <div class="actions">
            <ng-content select="[card-actions]"></ng-content>
        </div>
    </div>
}
<div class="content" [ngStyle]="{ height: contentHeight }">
    <ng-content select="[card-body]"></ng-content>
</div>
